import { render } from "./Home.vue?vue&type=template&id=1219a6b0"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "/Users/daiabromberg/Downloads/Parsons_Spring/MS2/msdv-thesis/Project/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__